// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d84fd3f2","866":"0c098163"}[chunkId] + ".chunk.js";
};